
export class Item_Type {

    protected static itemMap = {
        100000: 'group',
        120000: 'folder',
        140000: 'file',

        200100: 'link',
        200200: 'notification',
        200300: 'album',
        200400: 'post'
    };



    // TYPE_GROUP          = 100000,
    // TYPE_FOLDER         = 120000,
    // TYPE_FILE           = 140000,
    // TYPE_LINK           = 200100,
    // TYPE_NOTIFICATION   = 200200,
    // TYPE_ALBUM          = 200300,
    // TYPE_POST           = 200400,


    protected static itemStrCN = {
        100000: '群组',
        120000: '文件夹',
        140000: '文件',
        200100: '链接',
        200200: '通知',
        200300: '专辑',
        200400: '贴子'
    };

    public static getTypes() {
        return  this.itemMap;
    }

    public static getTypeString() {
        return  this.itemStrCN;
    }

    public static isFolderType(type) {
        return  120000 === Math.ceil(type);
    }

}
